module.exports = __webpack_public_path__ + "img/0018.201c905a.jpg";